$(document).ready(function() {
    setTimeout(function() {if (!$.cookie('hadProductPageStatic')) {$('#product-page-store-offering').fadeIn();} else {}}, 1000);
  $('.button-no > a').click(function(){    
    $('#product-page-store-offering').fadeOut();
    $.cookie('hadProductPageStatic', true, { expires: 1, path: '/' });
    return false;    
  });  
  $('.collection-offering-close a').click(function(){
    $.magnificPopup.close();
    return false;
    });  
  $('ul.tabs').each(function(){
        var active, content, links = $(this).find('a');
        active = links.first().addClass('active');
        content = $(active.attr('href'));
        links.not(':first').each(function () {
          $($(this).attr('href')).hide();
        });
        $(this).find('a').click(function(e){
          active.removeClass('active');
          content.hide();
          active = $(this);
          content = $($(this).attr('href'));
          active.addClass('active');
          content.show();
          return false;
        });
      });  
  $('.open-popup').click(function(){  
  $.magnificPopup.open({
   items: {src: '#subscription-popup'},
   type: 'inline'
   }); 
  return false;
  });  
  if(!$.cookie('hadPopup') && $('#subscription-popup').length){
      $.cookie('hadPopup', true, { expires: 3, path: '/' });  
    setTimeout(function() {
     if ($('#subscription-popup').length) {
       $.magnificPopup.open({
        items: {src: '#subscription-popup' },
        type: 'inline'
          });
       }
     }, 5000);
  } else {    
  };
  if(!$.cookie('hadOffer') && $('#offering-popup').length){
      $.cookie('hadOffer', true, { expires: 1, path: '/' });    
    setTimeout(function() {
     if ($('#offering-popup').length) {
       $.magnificPopup.open({
        items: {src: '#offering-popup'},
        type: 'inline'
          });
       }
     }, 5000);
  } else {    
  }; 
});
